var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9" },
              [
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "화학자재 기본정보" },
                  },
                  [
                    _c(
                      "template",
                      { slot: "card-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _vm.editable
                              ? _c("c-btn", {
                                  attrs: {
                                    url: _vm.saveUrl,
                                    isSubmit: _vm.isSave,
                                    param: _vm.data,
                                    mappingType: _vm.mappingType,
                                    label: "저장",
                                    icon: "save",
                                  },
                                  on: {
                                    beforeAction: _vm.saveInfo,
                                    btnCallback: _vm.saveCallback,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-text", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              label: "제품명",
                              name: "materialName",
                            },
                            model: {
                              value: _vm.data.materialName,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "materialName", $$v)
                              },
                              expression: "data.materialName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "모델명",
                              name: "deliveryVendorCd",
                            },
                            model: {
                              value: _vm.data.deliveryVendorCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "deliveryVendorCd", $$v)
                              },
                              expression: "data.deliveryVendorCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-plant", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              type: "edit",
                              name: "plantCd",
                            },
                            model: {
                              value: _vm.data.plantCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "plantCd", $$v)
                              },
                              expression: "data.plantCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-select", {
                            attrs: {
                              required: true,
                              comboItems: _vm.mixFlagItems,
                              type: "edit",
                              itemText: "codeName",
                              itemValue: "code",
                              name: "mixFlag",
                              label: "물질구성",
                            },
                            model: {
                              value: _vm.data.mixFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "mixFlag", $$v)
                              },
                              expression: "data.mixFlag",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              required: _vm.data.mixFlag == "N",
                              editable: _vm.editable,
                              label: "CAS No.",
                              name: "casNo",
                            },
                            model: {
                              value: _vm.data.casNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "casNo", $$v)
                              },
                              expression: "data.casNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-1" },
                        [
                          _c("c-checkbox", {
                            attrs: {
                              editable: _vm.editable,
                              isFlag: true,
                              label: "사용여부",
                              name: "useFlag",
                            },
                            model: {
                              value: _vm.data.useFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "useFlag", $$v)
                              },
                              expression: "data.useFlag",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-select", {
                            attrs: {
                              codeGroupCd: "CHM_IN_TYPE_CD",
                              type: "edit",
                              itemText: "codeName",
                              itemValue: "code",
                              name: "usageCd",
                              label: "자재/제품 유형",
                            },
                            model: {
                              value: _vm.data.usageCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "usageCd", $$v)
                              },
                              expression: "data.usageCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-select", {
                            attrs: {
                              required: true,
                              codeGroupCd: "PRODUCT_CATEGORY_CD",
                              type: "edit",
                              itemText: "codeName",
                              itemValue: "code",
                              name: "productCategoryCd",
                              label: "GHS분류 대상",
                            },
                            on: { datachange: _vm.ghsChange },
                            model: {
                              value: _vm.data.productCategoryCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "productCategoryCd", $$v)
                              },
                              expression: "data.productCategoryCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "MSDS번호",
                              name: "usageEtc",
                            },
                            model: {
                              value: _vm.data.usageEtc,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "usageEtc", $$v)
                              },
                              expression: "data.usageEtc",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-5" },
                        [
                          _c("c-checkbox", {
                            attrs: {
                              editable: _vm.editable,
                              isFlag: true,
                              label: "유해위험방지계획서 여부",
                              name: "psmFlag",
                            },
                            on: { datachange: _vm.psmChange },
                            model: {
                              value: _vm.data.psmFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "psmFlag", $$v)
                              },
                              expression: "data.psmFlag",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c(
                  "c-table",
                  {
                    ref: "processTable",
                    attrs: {
                      title: "공정명(부서)",
                      tableId: "processTable",
                      columns: _vm.gridprocess.columns,
                      data: _vm.gridprocess.data,
                      gridHeight: "188px",
                      isFullScreen: false,
                      columnSetting: false,
                      selection: "multiple",
                      rowKey: "mdmMaterialProcessId",
                      filtering: false,
                      usePaging: false,
                      hideBottom: true,
                      isExcelDown: false,
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "table-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _vm.editable && _vm.param.mdmChemMaterialId
                              ? _c("c-btn", {
                                  attrs: { label: "추가", icon: "add" },
                                  on: { btnClicked: _vm.addrowProcess },
                                })
                              : _vm._e(),
                            _vm.editable && _vm.param.mdmChemMaterialId
                              ? _c("c-btn", {
                                  attrs: { label: "삭제", icon: "remove" },
                                  on: { btnClicked: _vm.removeRowProcess },
                                })
                              : _vm._e(),
                            _vm.editable && _vm.param.mdmChemMaterialId
                              ? _c("c-btn", {
                                  attrs: { label: "저장", icon: "save" },
                                  on: { btnClicked: _vm.saveProcess },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm.data.productCategoryCd == "PCC0000001"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                  },
                  [
                    _c(
                      "c-card",
                      {
                        staticClass: "cardClassDetailForm",
                        attrs: { title: "물리화학적 특성정보" },
                      },
                      [
                        _c("template", { slot: "card-detail" }, [
                          _c(
                            "div",
                            { staticClass: "col-3" },
                            [
                              _c("c-select", {
                                attrs: {
                                  codeGroupCd: "PROPERTIES_STATE_CD",
                                  type: "edit",
                                  itemText: "codeName",
                                  itemValue: "code",
                                  name: "propertiesStateCd",
                                  label: "성상",
                                },
                                model: {
                                  value: _vm.data.propertiesStateCd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "propertiesStateCd", $$v)
                                  },
                                  expression: "data.propertiesStateCd",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-3" },
                            [
                              _c("c-text", {
                                attrs: {
                                  editable: _vm.editable,
                                  label: "pH",
                                  name: "phValue",
                                },
                                model: {
                                  value: _vm.data.phValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "phValue", $$v)
                                  },
                                  expression: "data.phValue",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-3" },
                            [
                              _c("c-text", {
                                attrs: {
                                  editable: _vm.editable,
                                  label: "끓는점",
                                  suffix: "℃",
                                  name: "boilingPoint",
                                },
                                model: {
                                  value: _vm.data.boilingPoint,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "boilingPoint", $$v)
                                  },
                                  expression: "data.boilingPoint",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-3" },
                            [
                              _c("c-text", {
                                attrs: {
                                  editable: _vm.editable,
                                  label: "인화점",
                                  suffix: "℃",
                                  name: "flashingPoint",
                                },
                                model: {
                                  value: _vm.data.flashingPoint,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "flashingPoint", $$v)
                                  },
                                  expression: "data.flashingPoint",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("c-select", {
                                attrs: {
                                  codeGroupCd: "HYDROCARBON_TYPE_CD",
                                  editable: _vm.editable,
                                  type: "edit",
                                  itemText: "codeName",
                                  itemValue: "code",
                                  name: "hydrocarbonTypeCd",
                                  label: "탄화수소류",
                                },
                                model: {
                                  value: _vm.data.hydrocarbonTypeCd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "hydrocarbonTypeCd", $$v)
                                  },
                                  expression: "data.hydrocarbonTypeCd",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-3" },
                            [
                              _c("c-text", {
                                attrs: {
                                  editable: _vm.editable,
                                  label: "용해도",
                                  suffix: "mg/L",
                                  name: "solubility",
                                },
                                model: {
                                  value: _vm.data.solubility,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "solubility", $$v)
                                  },
                                  expression: "data.solubility",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-3" },
                            [
                              _c("c-text", {
                                attrs: {
                                  editable: _vm.editable,
                                  label: "점도",
                                  suffix: "mm2/s at 40℃",
                                  name: "viscosity",
                                },
                                model: {
                                  value: _vm.data.viscosity,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "viscosity", $$v)
                                  },
                                  expression: "data.viscosity",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                    _c(
                      "c-card",
                      {
                        staticClass: "cardClassDetailForm",
                        attrs: { title: "위험물 운송규정" },
                      },
                      [
                        _c("template", { slot: "card-detail" }, [
                          _c(
                            "div",
                            { staticClass: "col-4" },
                            [
                              _c("c-text", {
                                attrs: {
                                  editable: _vm.editable,
                                  label: "UN No.",
                                  name: "unNo",
                                },
                                model: {
                                  value: _vm.data.unNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "unNo", $$v)
                                  },
                                  expression: "data.unNo",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-4" },
                            [
                              _c("c-text", {
                                attrs: {
                                  editable: _vm.editable,
                                  label: "위험등급",
                                  name: "dangerGrade",
                                },
                                model: {
                                  value: _vm.data.dangerGrade,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "dangerGrade", $$v)
                                  },
                                  expression: "data.dangerGrade",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-4" },
                            [
                              _c("c-select", {
                                attrs: {
                                  codeGroupCd: "BOTTLE_GRADE",
                                  type: "edit",
                                  itemText: "codeName",
                                  itemValue: "code",
                                  name: "bottleGrade",
                                  label: "용기등급",
                                },
                                model: {
                                  value: _vm.data.bottleGrade,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "bottleGrade", $$v)
                                  },
                                  expression: "data.bottleGrade",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }